module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.25482/images/productIcons/BreezeIntelligence.svg"